import KIconArrow from './Arrow.vue'
import KIconCheck from './Check.vue'
import KIconEyeExam from './EyeExam.vue'
import KIconGlasses from './Glasses.vue'
import KIconInfo from './Info.vue'
import KIconInformation from './Information.vue'
import KIconClose from './Close.vue'
import KIconPencil from './Pencil.vue'
import KIconRestart from './Restart.vue'
import KIconKeyboardArrowLeft from './KeyboardArrowLeft.vue'
import KIconKeyboardArrowRight from './KeyboardArrowRight.vue'
import KIconPlusProvider from './PlusProvider.vue'
import KIconHandle from './Handle.vue'
import KIconLink from './Link.vue'
import KIconLoadingDots from './LoadingDots.vue'

export const icons = {
  arrow: KIconArrow,
  check: KIconCheck,
  close: KIconClose,
  'eye-exam': KIconEyeExam,
  info: KIconInfo,
  information: KIconInformation,
  glasses: KIconGlasses,
  'keyboard-arrow-left': KIconKeyboardArrowLeft,
  'keyboard-arrow-right': KIconKeyboardArrowRight,
  pencil: KIconPencil,
  'plus-provider': KIconPlusProvider,
  restart: KIconRestart,
  handle: KIconHandle,
  link: KIconLink,
  dots: KIconLoadingDots
}

export type IconName = keyof typeof icons

export const iconNames = Object.keys(icons)
